import React from 'react';
import PropTypes from 'prop-types';

import useShowStatusbar from 'lib/hooks/useShowStatusbar';

import './PageLayout.scss';

const PageLayoutHeader = React.forwardRef(({children}, ref) => (
  <div ref={ref} className="bootstrap-iso page-layout-header">
    {children}
  </div>
));

const PageLayoutContent = React.forwardRef(({children}, ref) => {
  const hasStatusbar = useShowStatusbar();

  return (
    <div ref={ref} className={`page-layout-content ${hasStatusbar ? 'with-statusbar' : ''}`}>
      {children}
    </div>
  );
});

const PageLayout = React.forwardRef(({children}, ref) => (
  <div ref={ref} className="page-layout">
    {children}
  </div>
));

PageLayoutHeader.propTypes = {
  children: PropTypes.any.isRequired,
};

PageLayoutContent.propTypes = {
  children: PropTypes.any.isRequired,
};

PageLayout.propTypes = {
  children: PropTypes.any.isRequired,
};

PageLayout.Header = PageLayoutHeader;
PageLayout.Content = PageLayoutContent;

export default PageLayout;
